import { createHandlerChainRunner, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@wausauCustomBlueprint/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ returnPO: string } & HasOnComplete<void>>;
const DispatchUpdateReturnPONumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/RequestRMA/SetReturnPO",
        returnPO: props.parameter.returnPO,
    });
};

export const FireOnComplete: HandlerType = ({ parameter: { onComplete } }) => {
    onComplete?.();
};

export const chain = [DispatchUpdateReturnPONumber, FireOnComplete];

const wausauRequestRMASetReturnPO = createHandlerChainRunner(chain, "WausauRequestRMASetReturnPO");
export default wausauRequestRMASetReturnPO;
